import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import {
  DataService,
  ActivityFactory,
  ActivityUtilities,
  Utilities,
  SecurityService,
  WorkflowService,
  WorkflowContextService
} from 'src/app/services';
import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  DOCUMENT,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  User,
  WorkflowApplication,
  ApplicationStatus,
  Actions,
  WorkflowType
} from 'src/app/models';
import { Activity, ActivityModel } from 'src/app/models/activities';
import { PaymentRequest } from 'src/app/models/activities/payment-activity';
import { ToastrService } from 'ngx-toastr';
import { GPErrorHandler } from 'src/app/services/gp-error';
import { Subscription } from 'rxjs';
import { EditApplicationNumberComponent } from 'src/app/components/workflow/edit-application-number/edit-application-number.component';
import { JanusApplicationSummaryData } from '../inline-applications-card.model';
import { svgs } from 'src/assets/export.assets';
import { ApplicationPrintSummaryComponent } from 'src/app/views/workflow/application-print-summary/application-print-summary.component';

@Component({
  selector: 'wm-edit-application-janus',
  templateUrl: './edit-application-janus.component.html',
  styleUrls: ['./edit-application-janus.component.css'],
  standalone: false
})
export class EditApplicationJanusComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  printIcon = svgs.printIcon.name;
  applicationWorkflowIcon = svgs.applicationWorkflowIcon.name;
  @Input() appID: string;
  @Input() janusApplicationSummaryDetails!: JanusApplicationSummaryData;
  isPrintApplication : boolean  = false;
  submitter: User;
  application: WorkflowApplication;
  workflowId: string;
  applicationUrl: string;
  currentActivity: any;
  summaryActivities: Activity<ActivityModel>[];
  paymentRequests: PaymentRequest[];
  printMode = false;
  showUnDiscardButton = false;
  showReopenApplicationButton = false;
  showReopenClosedApplicationButton = false;
  isTestApplication: boolean;
  totalPaid: number;
  fees = [];
  isEntitledToUnvoid = false;
  isChildApplication = false;
  registrationId: string;
  applicationWorkflowType: WorkflowType;
  WorkflowType = WorkflowType;
  applicationStatus: ApplicationStatus;
  ApplicationStatus = ApplicationStatus;
  canViewVersion = false;
  canEditCompletedApplication = false;
  canReopenApplication = false;
  canReopenClosedApplication = false;
  clientSub: Subscription;
  @ViewChild('RecalculateDescription', { static: true })
  recalculateDescriptionModal: ModalConfirmComponent;
  @ViewChild('UndiscardApplication')
  undiscardApplicationModal: ModalConfirmComponent;
  @ViewChild('reopenApplication')
  reopenApplicationModal: ModalConfirmComponent;
  canEditApplicationNumber = false;
  @ViewChild('editAppNumber', { static: false })
  editAppNumber: EditApplicationNumberComponent;

  @ViewChild('printSection') printSection!: ElementRef;
  @ViewChild(ApplicationPrintSummaryComponent, { static: false })
  printSummaryComponent: ApplicationPrintSummaryComponent;

  apiBase = Utilities.getRootURL();

  topMargin: number;

  constructor(
    private _service: DataService,
    private _route: ActivatedRoute,
    private _workflowSvc: WorkflowService,
    public context: WorkflowContextService,
    private _router: Router,
    private _toastr: ToastrService,
    private _securitySvc: SecurityService,
    @Inject(DOCUMENT) private document: Document,
    private _errorHandler: GPErrorHandler,
    private ref: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['janusApplicationSummaryDetails'] &&
      changes['janusApplicationSummaryDetails'].currentValue
    ) {
      this.getApplication();
    }
  }

  ngAfterViewInit(): void {
    if (this.printMode) {
      this.document.body.style.backgroundColor = 'white';
    }
  }

  ngOnInit() {
    const init = () => {
      this._securitySvc
        .isLoginEntitled(Actions.VIEW_APPLICATION_VERSION)
        .subscribe(r => {
          this.canViewVersion = r;
        });
      this._securitySvc
        .isLoginEntitled(Actions.EDIT_COMPLETED_APPLICATIONS)
        .subscribe(r => {
          this.canEditCompletedApplication = r;
        });

      this._securitySvc
        .isLoginEntitled(Actions.REOPEN_COMPLETED_APPLICATION)
        .subscribe(r => {
          this.canReopenApplication = r;
        });

      this._securitySvc
        .isLoginEntitled(Actions.WORKFLOW_APPLICATIONS_EDIT)
        .subscribe(r => {
          this.isEntitledToUnvoid = r;
          this.canReopenClosedApplication = r;
        });

      this._securitySvc
        .isLoginEntitled(Actions.EDIT_APPLICATION_NUMBER)
        .subscribe(r => {
          this.canEditApplicationNumber = r;
        });
    };

    if (this.context.client) {
      init();
    } else {
      this.clientSub = this.context.client$.subscribe(client => {
        if (!client) {
          return;
        }
        init();
      });
    }
  }

  printApplication(): void {

    const printContents = this.printSection.nativeElement.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;

    window.location.reload();
    this.isPrintApplication = false;
  }

  async onPrintApplicationClick() {
    this.isPrintApplication = true;
    // Force DOM update to stamp the print component
    this.ref.detectChanges();

    // Wait a brief tick for the ViewChild to become available
    await new Promise(resolve => setTimeout(resolve, 50));

    if (this.printSummaryComponent) {
      // Strictly AWAIT the notes fetch logic from the child!
      await this.printSummaryComponent.prepareForPrint();
      
      // Ensure any final DOM updates process before snapshot
      this.ref.detectChanges();
      await new Promise(resolve => setTimeout(resolve, 100));
    } else {
      // Fallback if component is missing
      await new Promise(resolve => setTimeout(resolve, 500));
    }

    this.printApplication();
  }

  editApplicationNumber() {
    this.editAppNumber.open();
  }

  canUnVoid(): boolean {
    return (
      this.application.status === ApplicationStatus.Voided &&
      this.isEntitledToUnvoid
    );
  }

  returnToParent() {
    this._router.navigate([
      'application',
      'workflow-application',
      this.application.parentApplicationId
    ]);
  }

  startRenewalApplication() {
    this._workflowSvc
      .startRegistrationRenewal(this.registrationId)
      .subscribe(result => {
        this._router.navigate([
          '/application/workflow-application',
          result.applicationId
        ]);
      });
  }

  unVoid() {
    this._workflowSvc.undoCloseApplication(this.appID).subscribe(r => {
      this._toastr.success('Application Un-Voided');
      this._router.navigate([
        'application',
        'workflow-application',
        this.appID
      ]);
    });
  }

  undoCloseApplication() {
    this._workflowSvc.undoCloseApplication(this.appID).subscribe(r => {
      this._toastr.success('Application Reopened');
      this._router.navigate([
        'application',
        'workflow-application',
        this.appID
      ]);
    });
  }

  getApplication() {
    this.workflowId = this.janusApplicationSummaryDetails.workflowId;
    this.application = this.janusApplicationSummaryDetails.application;
    this.isTestApplication = this.janusApplicationSummaryDetails.application.isTestApplication;
    this.isChildApplication = this.janusApplicationSummaryDetails.application.hasParentApplication;
    this.registrationId = this.janusApplicationSummaryDetails.registrationId;
    this.applicationWorkflowType = this.janusApplicationSummaryDetails.workflowType;
    this.applicationStatus = this.janusApplicationSummaryDetails.application.status;
    this.showUnDiscardButton =
      this.janusApplicationSummaryDetails.application.status ===
      ApplicationStatus.Discarded;
    this.showReopenApplicationButton =
      this.janusApplicationSummaryDetails.application.status ===
        ApplicationStatus.Completed ||
      this.janusApplicationSummaryDetails.application.status ===
        ApplicationStatus.Rejected;
    this.showReopenClosedApplicationButton =
      this.janusApplicationSummaryDetails.application.status ===
        ApplicationStatus.Expired ||
      this.janusApplicationSummaryDetails.application.status ===
        ApplicationStatus.Locked ||
      this.janusApplicationSummaryDetails.application.status ===
        ApplicationStatus.Withdrawn;
    const activities = ActivityUtilities.convertActivitiesJsonToClasses(
      this.janusApplicationSummaryDetails.completedActivities
    );
    // convert the dictionary to an array
    const convertedActivities = Object.keys(activities).map(
      key => activities[key]
    );
    this.summaryActivities = convertedActivities;

    this.fees = this.janusApplicationSummaryDetails.fees;
    this.totalPaid = this.janusApplicationSummaryDetails.totalPaid;
    this.submitter = this.janusApplicationSummaryDetails.submitter;

    this._service.getPaymentRequests(this.appID).subscribe(requests => {
      this.paymentRequests = requests;
    });
  }

  exitTestApplication() {
    this._workflowSvc.cleanupTestApplication(this.appID).subscribe(
      a => {
        this.context.applicationId$.emit(null);
        this.context.viewAsRole$.emit(null);
        this._router.navigate([this.context.applicationReturnURL]);
      },
      err => {
        this._errorHandler.handleError(err);
      }
    );

    return false;
  }

  openApplicationWorkflowBuilder() {
    const workflowId = this.workflowId;
    const versionId = this.application.workflowVersionId;

    const url = this._router.serializeUrl(
      this._router.createUrlTree([
        '/admin/workflow-builder/',
        workflowId,
        versionId,
        this.application.id
      ])
    );

    window.open(url, '_blank');
  }

  undiscardApplication(force: boolean) {
    if (!force) {
      this.undiscardApplicationModal.open();
    } else {
      this._workflowSvc.undiscardApplication(this.appID).subscribe(app => {
        this.undiscardApplicationModal.cancel();
        this._router.navigate([
          '/application/workflow-application/',
          this.appID
        ]);
      });
    }
  }

  setApplicationBackToInProgress(force: boolean) {
    if (!force) {
      this.reopenApplicationModal.open();
    } else {
      this._workflowSvc.reopenApplication(this.appID).subscribe(result => {
        if (result) {
          this.reopenApplicationModal.cancel();
          this._router.navigate([
            '/application/workflow-application/',
            this.appID
          ]);
        } else {
          this._toastr.error(
            'Failed to set application to In Progress.  Please contact support if this error persists.'
          );
        }
      });
    }
  }

  recalculateApplicationDescription(force: boolean) {
    if (!force) {
      this.recalculateDescriptionModal.open();
    } else {
      this._workflowSvc
        .recalculateApplicationDescription(this.appID)
        .subscribe(appDescription => {
          this.application.description = appDescription;
          this.recalculateDescriptionModal.cancel();
        });
    }
  }

  setTopMarginForNavbar(pixelHeight: number) {
    this.topMargin = pixelHeight;
  }
}
